var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.933 16.933",
    id: "CsvFile",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.968,
    transform: "matrix(1.03366 0 0 1.03333 -2.911 3.935)",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.9217235,-3.8085938 A 0.25603411,0.25603411 0 0 0 4.6658641,-3.5527344 V 12.322266 a 0.25603411,0.25603411 0 0 0 0.2558594,0.255859 H 17.093598 a 0.25603411,0.25603411 0 0 0 0.255859,-0.255859 V 1.3886719 a 0.25603411,0.25603411 0 0 0 -0.07227,-0.1796875 l -4.796875,-4.9179688 v -0.00195 a 0.25600851,0.25600851 0 0 0 -0.01953,-0.019531 0.25600851,0.25600851 0 0 0 -0.02149,-0.019531 0.25600851,0.25600851 0 0 0 -0.02344,-0.017578 0.25600851,0.25600851 0 0 0 -0.02344,-0.013672 0.25600851,0.25600851 0 0 0 -0.01367,-0.00586 0.25600851,0.25600851 0 0 0 -0.02539,-0.00977 0.25600851,0.25600851 0 0 0 -0.01367,-0.00391 0.25600851,0.25600851 0 0 0 -0.0059,0 0.25600851,0.25600851 0 0 0 -0.03711,-0.00586 0.25600851,0.25600851 0 0 0 -0.01367,-0.00195 0.25600851,0.25600851 0 0 0 -0.0059,0 h -0.0078 z m 0.2558594,0.5117188 h 6.9902341 l 4.669922,4.7890625 V 12.066406 H 5.1775829 Z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.269531 -3.8085938 A 0.25603411 0.25603411 0 0 0 12.021484 -3.5527344 L 12.021484 1.3886719 A 0.25603411 0.25603411 0 0 0 12.277344 1.6445312 L 17.09375 1.6445312 A 0.25603411 0.25603411 0 0 0 17.277344 1.2089844 L 12.460938 -3.7304688 A 0.25603411 0.25603411 0 0 0 12.269531 -3.8085938 z M 12.533203 -2.921875 L 16.488281 1.1328125 L 12.533203 1.1328125 L 12.533203 -2.921875 z ",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      lineHeight: 2,
      InkscapeFontSpecification: "Calibri",
      textAlign: "center"
    },
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.265,
    "aria-label": "CSV",
    fontFamily: "Calibri",
    fontSize: 5.292,
    opacity: 0.99,
    textAnchor: "middle",
    className: "colorStroke000000 svgStroke"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#437ef7",
    stroke: "none",
    d: "M6.953264 14.69161q0 .04134-.00258.07235-.00258.03101-.010335.05426-.00517.02325-.015503.04134-.010335.01809-.036174.04392-.025838.02584-.1085205.0801-.082682.05168-.2067059.103353-.1214397.04909-.2816367.08268-.1576132.03617-.3462323.03617-.3255617 0-.5891117-.108521-.2609661-.10852-.4470014-.320394-.1834515-.211873-.2842206-.521932-.098185-.312643-.098185-.718303 0-.415995.1059367-.741557.1085206-.325562.3023073-.550354.1937868-.227377.4625044-.346233.2713014-.118856.5994469-.118856.1446941 0 .2816368.02842.1369426.02584.2532146.06718.1162721.04134.2067059.0956.090434.05426.1240235.09043.036173.03359.046509.05168.010335.01809.015503.04392.00775.02325.010335.05684.00517.03359.00517.0801 0 .05168-.00517.08785-.00517.03617-.015503.06201-.010335.02325-.025838.03617-.012919.01034-.03359.01034-.036174 0-.1007691-.04909-.064596-.05168-.1679485-.111104-.1007691-.06201-.2480471-.111105-.1446941-.05168-.3488161-.05168-.2222088 0-.4056602.09043-.1808676.08785-.3100588.260966-.1291912.173116-.2015382.423747-.069763.248047-.069763.568441 0 .31781.067179.563273.069763.24288.1963705.408244.1291912.162781.3152265.248047.1860352.08268.4211631.08268.1989544 0 .3462323-.04909.1498618-.04909.2532147-.10852.1059368-.06201.1731162-.111105.067179-.04909.1059367-.04909.018087 0 .031006.0078.012919.0078.020671.03101.00775.02067.010335.05943.00517.03876.00517.09819zM9.3381328 14.226522q0 .235128-.08785.418579-.085266.183452-.2402956.312643-.1524455.126607-.3617352.191203-.2067059.0646-.4470014.0646-.1679485 0-.3126426-.02842-.1421103-.02842-.2557985-.06976-.1111044-.04134-.1886191-.08527-.074931-.04392-.1059368-.07493-.028422-.03101-.043925-.07752-.012919-.04909-.012919-.129191 0-.05684.00517-.09302.00517-.03876.015503-.06201.010335-.02326.025838-.03101.015503-.01033.036174-.01033.036174 0 .1007691.04392.067179.04392.1705323.0956.1033529.05168.248047.09818.1472779.04392.3384809.04392.1446941 0 .2635499-.03876.1214397-.03876.2067059-.108521.08785-.07235.1343588-.1757.046509-.103352.046509-.235127 0-.142111-.064596-.24288-.064596-.100769-.1705323-.1757Q8.5319799 13.77952 8.3950373 13.717509 8.2606785 13.652913 8.1185682 13.588318 7.976458 13.521138 7.8420992 13.44104 7.7077403 13.360941 7.6018036 13.252421 7.4958668 13.1439 7.4286874 12.999206q-.064596-.147278-.064596-.3514 0-.20929.074931-.372071.077515-.165364.2118735-.276469.1369427-.111104.3229779-.167948.1886191-.05943.4056603-.05943.1111044 0 .2222088.02067.1136882.01809.2118735.05168.1007691.03101.1782838.07235.077515.03876.1007691.0646.025838.02325.03359.03876.00775.01292.012919.03617.00517.02067.00775.05168.00258.03101.00258.0801 0 .04651-.00517.08268-.00258.03617-.010335.06201-.00775.02325-.023254.03617-.012919.01033-.031006.01033-.028422 0-.090434-.03617-.059428-.03617-.1472779-.0801-.08785-.04651-.2092897-.08268-.1188558-.03876-.2687176-.03876-.1395264 0-.2428793.03876-.103353.03617-.1705324.09818-.067179.06201-.1007691.147278-.03359.08527-.03359.180868 0 .139526.064596.240295.064596.100769.1705323.178284.1085206.07752.2454632.14211.1369427.0646.2790529.131775.1421103.0646.2790529.144694.1369427.07752.2428794.186036.1085206.105936.1731162.253214.067179.144694.067179.343649zM11.291503 15.086935q-.01034.02842-.02842.04651-.01809.01809-.05168.02842-.03101.01033-.08268.01292-.04909.0052-.124023.0052-.05684 0-.100769-.0026-.04134 0-.07235-.0052-.031-.0052-.05426-.01033-.02067-.0078-.03617-.01809-.0155-.01033-.02584-.02325-.0078-.0155-.0155-.03617L9.6068503 11.978596q-.020671-.05684-.023254-.09043 0-.03617.023254-.05426.023254-.01809.074931-.02326.051676-.0052.1395264-.0052.072347 0 .1136882.0052.043925.0026.067179.01292.02326.01034.03359.02842.01292.0155.02325.04134l.958599 2.813783h.0026l.93276-2.808616q.0078-.02842.01809-.04651.01034-.01809.03617-.02842.02584-.01033.07235-.01292.04651-.0052.124024-.0052.0801 0 .126607.0078.04651.0052.06201.02325.01809.01809.01292.05426-.0026.03359-.02326.09043z",
    fontWeight: 400,
    className: "color000000 svgShape"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.10ae197a1398a990b13077e1f644549f.svg";
export { ForwardRef as ReactComponent };